<template>
  <v-tooltip
    top
    transition="fade-transition"
    reverse-transition="fade-transition"
  >
    <template #activator="{ on, attrs }">
      <v-avatar :size="size">
        <img
          v-if="doHaveProfile"
          :src="defaultPhotoProfile"
          alt="Profile Picture"
          v-bind="
            typeof tooltipWording !== 'undefined' &&
            tooltipWording !== '' &&
            tooltipWording !== null
              ? attrs
              : null
          "
          v-on="
            typeof tooltipWording !== 'undefined' &&
            tooltipWording !== '' &&
            tooltipWording !== null
              ? on
              : null
          "
        />

        <img
          v-else
          :src="picUrl"
          alt="Profile Picture"
          v-bind="
            typeof tooltipWording !== 'undefined' &&
            tooltipWording !== '' &&
            tooltipWording !== null
              ? attrs
              : null
          "
          v-on="
            typeof tooltipWording !== 'undefined' &&
            tooltipWording !== '' &&
            tooltipWording !== null
              ? on
              : null
          "
        />
      </v-avatar>
    </template>

    <span>
      {{ tooltipWording }}
    </span>
  </v-tooltip>
</template>

<script>
import { isEmpty } from "lodash-es";
import { DEFAULT_PHOTO_PROFILE } from "@/src/image";

export default {
  name: "ProfilePicture",

  props: {
    picUrl: {
      type: String,
      default: "",
    },
    size: {
      type: Number,
      default: 100,
    },
    tooltipWording: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      defaultPhotoProfile: DEFAULT_PHOTO_PROFILE,
    }
  },

  computed: {
    doHaveProfile() {
      const isProfile = isEmpty(this.picUrl);
      return isProfile;
    },
  },
};
</script>

<style scoped>
img {
  object-fit: cover;
}
</style>
